import React, { Component } from 'react';
import GradientChart from './GradientChart'; 
import HistoricInflowChart from './HistoricInflowChart';
//import HistoricInflowChart from './HistoricInflowChart_without_intimation_loading.js';
import LongTermDailyChart from './LongTermDailyChart';
import LongTermMonthlyChart from './LongTermMonthlyChart';
import FlowDurationChart from './FlowDurationChart';
import close from "../../minimise_button.png";

class GraphOptionsBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedChart: 'In-season',
      isMinimized: false,
      position: { x: 0, y: 0 }, // Initial position for dragging

    };
  }
  handleMinimizeClick = () => {
    this.props.toggleVisibleGraphPanel();
    // Toggle the state to indicate whether the component is minimized or not
    this.setState((prevState) => ({
      isMinimized: !prevState.isMinimized,
    }));
  }
  

  handleGraphChange = (chartName) => {
    this.setState({ selectedChart: chartName });
  };
  handleDrag = (e, ui) => {
    const { x, y } = ui;
    this.setState({ position: { x, y } });
  };
  


  render() {
    const { selectedChart,isMinimized,position } = this.state;

    return (
      
      <div className={`graph-options-box ${isMinimized ? 'minimized' : ''}`}>
  
      <div
        className="minimize-button"
        onClick={this.handleMinimizeClick}
      >
        <img src={close} width="20" height="21" alt="Minimize" />
      </div>

      {!isMinimized && (
        <div className="custom-button-container">
      

        
        <div  style={{
            backgroundColor: '#f2f6f7',
            whiteSpace: 'nowrap', // Prevent button wrapping
            overflowX: 'auto',   // Enable horizontal scrolling
          }}>
          <button
            className={`custom-button bold-text ${selectedChart === 'In-season' ? 'activated' : ''}`}
            onClick={() => this.handleGraphChange('In-season')}
          >
            In-season <br /> Inflow
          </button>
          <button
            className={`custom-button bold-text ${selectedChart === 'Historic Inflow' ? 'activated' : ''}`}
            onClick={() => this.handleGraphChange('Historic Inflow')}
          >
            Historic Inflow <br /> Simulation
          </button>
          <button
            className={`custom-button bold-text ${selectedChart === 'Long term Daily Average' ? 'activated' : ''}`}
            onClick={() => this.handleGraphChange('Long term Daily Average')}
          >
            Long Term Daily <br /> Average
          </button>
          <button
            className={`custom-button bold-text ${selectedChart === 'Long term Monthly Average' ? 'activated' : ''}`}
            onClick={() => this.handleGraphChange('Long term Monthly Average')}
          >
            Long Term Monthly <br /> Average
          </button>
          <button
            className={`custom-button bold-text ${selectedChart === 'Flow Duration Curve' ? 'activated' : ''}`}
            onClick={() => this.handleGraphChange('Flow Duration Curve')}
          >
            Flow Duration <br /> Curve
          </button>
        </div>
        <div>



         
          {selectedChart === 'In-season' && (
            <GradientChart
              rname={this.props.rname}
              data={this.props.data}
              curr_date={this.props.curr_date}
              toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
              flow_returnPer={this.props.flow_returnPer}
              year_returnPer={this.props.year_returnPer}
              date={this.props.date}
              className={`chart ${selectedChart === 'In-season' ? 'visible' : 'hidden'}`}

            />
          )}
          {selectedChart === 'Historic Inflow' && (
            <HistoricInflowChart
              rname={this.props.reservoirHistname}
              data={this.props.flow_hist}
              dates={this.props.dates_hist}
              curr_date={this.props.curr_date}
              toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
              flow_returnPer={this.props.flow_returnPer}
              year_returnPer={this.props.year_returnPer}
              date={this.props.date}

              className={`chart ${selectedChart === 'Historic Inflow' ? 'visible' : 'hidden'}`}

            />
          )}
          {selectedChart === 'Long term Daily Average' && (
            <LongTermDailyChart
              rname={this.props.reservoirLongdailyname}
              data={this.props.flow_dailyAvg}
              dates={this.props.dates_dailyAvg}
              curr_date={this.props.curr_date}
              date={this.props.date}

              toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
            />
          )}
          {selectedChart === 'Long term Monthly Average' && (
            <LongTermMonthlyChart
              rname={this.props.reservoirLongMonthname}
              data={this.props.flow_monthlyAvg}
              dates={this.props.month_monthlyAvg}
              curr_date={this.props.curr_date}
              date={this.props.date}

              toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
            />
          )}
          {selectedChart === 'Flow Duration Curve' && (
           
            <FlowDurationChart
              rname={this.props.reservoirFlowname}
              data={this.props.flow_flowDur}
              prob={this.props.prob_flowDur}
              curr_date={this.props.curr_date}
              date={this.props.date}

              toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
            />
            
         
          )} 

        </div>
      </div>
      )}
      </div>
    );
  }
}

export default GraphOptionsBox;
